import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-payment-link',
  templateUrl: './share-payment-link.component.html',
  styleUrls: ['./share-payment-link.component.css']
})
export class SharePaymentLinkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
